module.exports = __webpack_public_path__ + "img/sidebar.a5e56956.png";